__webpack_require__.p = "https://vmmv-uat.luxottica.com/v/5.6/";